import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userReducer from 'store/slices/user';
import companiesReducer from 'store/slices/companies';
import teamsReducer from 'store/slices/teams';

const rootReducer = combineReducers({
    userState: userReducer,
    companiesState: companiesReducer,
    teamsState: teamsReducer,
});

export const store = configureStore({
    reducer: rootReducer,
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
